import React, { Component } from "react";
import Icon from "../../icons";
export class InputBoxTooltip extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
          inputNumberText:"",
          inputNameText:"", 
          inputExtensionText:"",
          customerLastName: null,
          selectedOption: {},
          disableTick:false
        };
        this.onClickSubmit = this.onClickSubmit.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onHandleKeyDown = this.onHandleKeyDown.bind(this);
      }

      componentDidMount() {
        let phoneValue =  "";
        let extValue =  "";
        if(this.props.type!="name" ) {
          if(this.props.value.includes('(x')) {
            phoneValue = this.props.value.split('(x')[0];
            extValue =  this.props.value.split('(x')[1].replace(')','');
          } else {
            phoneValue = this.props.value;
          }
        }
        this.setState({
          inputNumberText:phoneValue,
          inputExtensionText:extValue,
          inputNameText:this.props.value,  
        })
      }
      
    
      onClickSubmit(type) {
         if(type==="name") {
             let name =  this.state.inputNameText.trim();
             if(name!=="") {
               this.props.onSubmitTooltip(name,this.props.type);
             }
         } else  {
            let phone =  this.state.inputNumberText.trim();
            let ext =  this.state.inputExtensionText.trim();
            let total = ext==="" || ext==null?phone:`${phone} (x${ext})`;
            if(phone!=="") {
              this.props.onSubmitTooltip(total,this.props.type);
            }
         } 
      }

      onClickCancel() {
        this.props.onCancelTooltip();
      }

      onHandleChange(e) {
        const {name,value} = e.target;
        
        if(name !=="inputExtensionText"){
         let disable = value===""?true:false;
         this.setState({
          [name]: value,
          disableTick:disable
        });
        } else {
          this.setState({
            [name]: value,
          });
        }
      }

      onHandleKeyDown(e,type) {
        if (e.keyCode === 13) {
          this.onClickSubmit(type);
        }
      }

  render() {
    return (
      <div>
        {this.props.type === "name" ? (
                  <div className="editable-header is-edit editable rowSpaceBetween ensurdEditable singleEditable">
                    <input  type="text" className="mr" onKeyDown={(e)=>this.onHandleKeyDown(e,this.props.type)} placeholder="Workkard owner" name="inputNameText" value={this.state.inputNameText} onChange={this.onHandleChange} />
                    <div className="extensionFill userFill">
                      <span className={`statusCheck mr__1 ${(this.state.disableTick ?'disableStatusCheck':'')}`} onClick={() => this.onClickSubmit("name")}>
                        <Icon name="check" className="icon activeIcon" />
                      </span>
                      <span onClick={this.onClickCancel}>
                        <Icon name="close" className="icon" />
                      </span>
                    </div>
                  </div>
        ) : (
              <div className="editable-header is-edit editable rowSpaceBetween ensurdEditable">
                <input  type="text"  className="mr" onKeyDown={(e)=>this.onHandleKeyDown(e,this.props.type)} name="inputNumberText" maxLength="15" placeholder="Phone number" value={this.state.inputNumberText} onChange={this.onHandleChange} />
                <input tabIndex={0} type="text" className="mr" onKeyDown={(e)=>this.onHandleKeyDown(e,this.props.type)} name="inputExtensionText" maxLength="5" placeholder="Add extension" value={this.state.inputExtensionText} onChange={this.onHandleChange} />
                <div className="extensionFill">
                  <span className={`statusCheck mr__1 ${(this.state.disableTick ?'disableStatusCheck':'')}`} onClick={()=>this.onClickSubmit(this.props.type)}>
                    <Icon name="check" className="icon activeIcon" />
                  </span>
                  <span className={`${(this.state.disableTick ?'disableStatusCheck':'')}`} onClick={this.onClickCancel}>
                    <Icon name="close" className="icon" />
                  </span>
                </div>
              </div>
        )}
      </div>
    );
  }
}

export default InputBoxTooltip;
